module.exports = __webpack_public_path__ + "media/favicons/android-chrome-512x512-7187bc3f.png";